/**
 * Pflichtfelder pro Reklamationstyp und D-Schritt.
 * Synchron zu backend/domains/complaint/step_validation_service.py
 * und backend/domains/complaint/complaint/complaint_create.py
 */

export const MANDATORY_FIELDS = {
  q1: {
    d0: [
      { label: 'Kunde', type: 'Text', source: 'Kundenkatalog' },
      { label: 'Kd-Nr.', type: 'Text', source: 'Kundenkatalog' },
      { label: 'Kontakt E-Mail', type: 'E-Mail', source: 'Manuell' },
      { label: 'Feststellungsdatum', type: 'Datum', source: 'Manuell' },
      { label: 'Meldedatum', type: 'Datum', source: 'Auto (heute)' },
      { label: 'Produktbezeichnung', type: 'Text', source: 'Manuell' },
      { label: 'Artikel-Nr.', type: 'Text', source: 'Produktkatalog' },
      { label: 'Betroffene Menge', type: 'Zahl', source: 'Manuell' },
      { label: 'Gelieferte Menge', type: 'Zahl', source: 'Manuell' },
      { label: 'Auftrag ODER Lieferschein', type: 'Text', source: 'Manuell (einer der beiden)' },
      { label: 'Vertriebs-Organisation', type: 'Auswahl', source: 'SAP' },
      { label: 'Vertriebsbüro', type: 'Auswahl', source: 'SAP' },
      { label: 'Verkäufergruppe', type: 'Auswahl', source: 'SAP' },
      { label: 'Problembeschreibung', type: 'Freitext', source: 'Manuell' },
    ],
    d1: [
      { label: 'Team-Mitglieder (min. 1)', type: 'Mitarbeiter', source: 'Userliste' },
      { label: 'Team-Leader', type: 'Mitarbeiter', source: 'Auto = Ersteller' },
    ],
    d2: [
      { label: 'Detaillierte Fehlerbeschreibung (5W+1H)', type: 'Freitext', source: 'Manuell' },
      { label: 'Fehlercode (min. 1 aus Katalog)', type: 'Auswahl', source: 'Fehlerkatalog' },
    ],
    d3: [{ label: 'Mindestens 1 Sofortmaßnahme', type: 'Maßnahme', source: 'Manuell/KI' }],
    d4: [{ label: 'Mindestens 1 Ursache (6M)', type: 'Ursache', source: 'Manuell/KI' }],
    d5: [{ label: 'Mindestens 1 Korrekturmaßnahme', type: 'Maßnahme', source: 'Manuell/KI' }],
    d6: [{ label: 'Wirksamkeit dokumentiert', type: 'Freitext + Nachweis', source: 'Manuell' }],
    d7: [{ label: 'Mindestens 1 Vorbeugungsmaßnahme', type: 'Maßnahme', source: 'Manuell/KI' }],
    d8: [{ label: 'Abschlussbewertung (Quality-Score freigegeben)', type: 'KI-Check', source: 'Automatisch' }],
  },
  q2: {
    d0: [
      { label: 'Lieferant', type: 'Auswahl', source: 'Lieferantenkatalog' },
      { label: 'Q2-Typ', type: 'Auswahl', source: 'aus Q1 | Wareneingang | Lohnfertigung' },
      { label: 'Gewünschter Report-Typ', type: 'Auswahl', source: '4D | 8D' },
      { label: 'Antwortfrist', type: 'Datum', source: 'Manuell' },
      { label: 'Problembeschreibung', type: 'Freitext', source: 'Manuell' },
      { label: 'Material-Nr. / Charge', type: 'Text', source: 'Manuell/Q1' },
    ],
    d1: [{ label: 'Interner Team-Leader', type: 'Mitarbeiter', source: 'Auto = Ersteller' }],
    d2: [{ label: 'Problem an Lieferant versendet', type: 'Aktion', source: 'Portal-Token' }],
  },
  q3: {
    d0: [
      { label: 'Abgebendes Werk (Verursacher)', type: 'Auswahl', source: 'Werksmatrix' },
      { label: 'Empfangendes Werk (Melder)', type: 'Auswahl', source: 'Werksmatrix' },
      { label: 'Charge / Batch-Nummer', type: 'Text', source: 'Manuell' },
      { label: 'Problembeschreibung', type: 'Freitext', source: 'Manuell' },
    ],
  },
};

export const STEP_KEYS = ['d0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8'];
